<template>
    <CreateJob></CreateJob>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const CreateJob = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/JobEntry/CreateJob.vue"
    )
);

export default {
    name: "Project_HelpCreateJob", //The name you are in should not equal the name of the component you are importing.
    components: { CreateJob, AuthLayout },
};
</script>
